// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M10.9706 12.0546H9.02738L9.99949 8.81422L10.9706 12.0546Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M22 2V22H2V2H22ZM11.2438 6H8.7559L5.15234 18H7.24379L8.42739 14.0546H11.57L12.7524 18H14.8437L11.2438 6ZM17.9997 9H15.9958V11.0039H17.9997V9ZM17.9997 18V12H15.9997V18H17.9997Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-logo-adobe-illustrate-filled')
export default class LogoAdobeIllustrateFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'logo-adobe-illustrate-filled',
    }
  }
}
